import { render, staticRenderFns } from "./CompetitorDeductionTab.vue?vue&type=template&id=6b722489"
import script from "./CompetitorDeductionTab.vue?vue&type=script&lang=js"
export * from "./CompetitorDeductionTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports